import { Box, Skeleton } from '@mui/material'

/** Full-screen skeleton while app bootstrap (session loading) is in progress */
export const AppSkeleton = () => (
	<Box
		data-testid="app-skeleton"
		sx={{
			position: 'absolute',
			inset: 0,
			zIndex: 3,
			display: 'flex',
			flexDirection: 'column',
			bgcolor: 'background.paper',
		}}
	>
		{/* Top bar placeholder */}
		<Box
			sx={{
				height: 56,
				borderBottom: 1,
				borderColor: 'divider',
				display: 'flex',
				alignItems: 'center',
				px: 2,
			}}
		>
			<Skeleton variant="rounded" width={120} height={32} />
			<Skeleton variant="rounded" width={200} height={32} sx={{ ml: 3 }} />
		</Box>
		{/* Main area */}
		<Box sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
			{/* Side panel placeholder */}
			<Box sx={{ width: 280, borderRight: 1, borderColor: 'divider', p: 2 }}>
				{[1, 2, 3, 4, 5, 6].map((i) => (
					<Skeleton key={i} variant="text" width={`${90 - i * 5}%`} height={24} sx={{ my: 0.5 }} />
				))}
			</Box>
			{/* Content placeholder */}
			<Box sx={{ flex: 1, p: 3 }}>
				<Skeleton variant="text" width={180} height={36} />
				<Skeleton variant="rounded" width="100%" height={240} sx={{ mt: 2 }} />
			</Box>
		</Box>
	</Box>
)
